import { type SnackbarStatus, actions } from 'redux/slices/snackbar.slices'
import { type AppDispatch } from 'redux/store'

export const showSnackbar = (message: string, status: SnackbarStatus) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(actions.showSnackbar({ message, status }))
  }
